import {
	permanentRedirect as nextPermanentRedirect,
	redirect as nextRedirect,
	notFound,
} from "next/navigation";
import {
	getPathname,
	Link,
	localizedPermanentRedirect,
	localizedRedirect,
	type RedirectTarget,
	type RedirectType,
	resolveRedirectTarget,
	UnlocalizedLink,
	usePathname,
	useRouter,
} from "./navigation.core";

export type { RedirectTarget, RedirectType };
export { getPathname, Link, notFound, UnlocalizedLink, usePathname, useRouter };

export function redirect(target: RedirectTarget, type?: RedirectType): never {
	const resolution = resolveRedirectTarget(target);
	if (resolution.kind === "native") {
		return nextRedirect(resolution.href, type);
	}
	return localizedRedirect(resolution.args, type);
}

export function permanentRedirect(
	target: RedirectTarget,
	type?: RedirectType,
): never {
	const resolution = resolveRedirectTarget(target);
	if (resolution.kind === "native") {
		return nextPermanentRedirect(resolution.href, type);
	}
	return localizedPermanentRedirect(resolution.args, type);
}
